import { useEffect, useState } from "react";
import api from "../../lib/api";

export function useEmailSettings() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/admin/email-settings").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);
  return settings;
}
